




































import { DeviceEnum, FilterIdEnum } from '../../enums';

import { getDatepickerI18nConfig, UiButton, UiDatepicker, UiModal } from '../keen-ui';

enum DateErrorsEnum {
  MIN_DATE = 'minDate',
  MAX_DATE = 'maxDate',
  MAX_PERIOD = 'maxPeriod'
}

export default {
  name: 'custom-date-selector',
  components: {
    UiButton,
    UiDatepicker,
    UiModal
  },
  computed: {
    datepickerProps: function () {
      return {
        ...getDatepickerI18nConfig(this.$epb.locale),
        orientation: ((this.$epb.device > DeviceEnum.MOBILE) ? 'landscape' : 'portrait'),
        pickerType: ((this.$epb.device > DeviceEnum.MOBILE) ? 'modal' : 'popover'),
        icon: 'calendar',
        placeholder: this.messages.customDate.placeholder
      };
    },
    minStartDate: function () {
      return (!!this.filter.config.minDateInMillis ? new Date(this.filter.config.minDateInMillis) : undefined);
    },
    maxStartDate: function () {
      if (!!this.scheduleDates.endDate.value && !this.scheduleDates.endDate.error) {
        return this.scheduleDates.endDate.value;
      }
      if (!!this.filter.config.maxDateInMillis) {
        return new Date(this.filter.config.maxDateInMillis);
      }
    },
    minEndDate: function () {
      if (!!this.scheduleDates.startDate.value && !this.scheduleDates.startDate.error) {
        return this.scheduleDates.startDate.value;
      }
      if (!!this.filter.config.minDateInMillis) {
        return new Date(this.filter.config.minDateInMillis);
      }
    },
    maxEndDate: function () {
      return (!!this.filter.config.maxDateInMillis ? new Date(this.filter.config.maxDateInMillis) : undefined);
    },
    modalSize: function () {
      return this.$epb.device === DeviceEnum.MOBILE ? 'fullscreen' : 'normal';
    },
    scheduleDatesValues: function (): string {
      return [this.scheduleDates.startDate.value, this.scheduleDates.endDate.value].join();
    }
  },
  data() {
    return {
      messages: this.$epb.messages.filters,
      scheduleDates: {
        startDate: {
          value: {},
          error: undefined
        },
        endDate: {
          value: {},
          error: undefined
        }
      }
    };
  },
  props: {
    filter: Object
  },
  methods: {
    open: function (): void {
      this.initializeDates();
      this.$refs.customDateModal.open();
    },
    close: function (): void {
      this.$refs.customDateModal.close();
    },
    getDateValidationErrors: function (date: Date) {
      const errors = [];
      if (!!this.filter.config.minDateInMillis && (date.getTime() < this.filter.config.minDateInMillis)) {
        errors.push(DateErrorsEnum.MIN_DATE);
      }
      if (!!this.filter.config.maxDateInMillis && (date.getTime() > this.filter.config.maxDateInMillis)) {
        errors.push(DateErrorsEnum.MAX_DATE);
      }
      return errors;
    },
    onAccept: function (): void {
      const startDate = new Date(this.scheduleDates.startDate.value);
      const startDateParsed = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
      const endDate = new Date(this.scheduleDates.endDate.value);
      const endDateParsed = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1));
      this.$emit('datesChange', [
        (!!this.scheduleDates.startDate.value ? startDateParsed.getTime() : undefined),
        (!!this.scheduleDates.endDate.value ? endDateParsed.getTime() : undefined)
      ]);
      this.close();
    },
    mapErrors: function (encodedErrors: []) {
      const toLocaleStringOptions = { year: '2-digit', month: 'short', day: '2-digit' } as const;
      return encodedErrors.map((errorId: string) => {
        return {
          [DateErrorsEnum.MIN_DATE]: () => this.$epb.utils.compileMessage(this.messages.errors[FilterIdEnum.DATE].minDate,
            {
              date: new Date(this.filter.config.minDateInMillis).toLocaleString(this.$epb.locale, toLocaleStringOptions)
            }),
          [DateErrorsEnum.MAX_DATE]: () => this.$epb.utils.compileMessage(this.messages.errors[FilterIdEnum.DATE].maxDate,
            {
              date: new Date(this.filter.config.maxDateInMillis).toLocaleString(this.$epb.locale, toLocaleStringOptions)
            }),
          [DateErrorsEnum.MAX_PERIOD]: () => this.$epb.utils.compileMessage(this.messages.errors[FilterIdEnum.DATE].maxPeriod,
            {
              period: this.filter.config.maxPeriodInMillis / 86400000
            })
        }[errorId]();
      }, this);
    },
    initializeDates: function (): void {
      this.scheduleDates.startDate.value = (!!this.filter.selectedValues[0] ? new Date(this.filter.selectedValues[0]) : undefined);
      const startDate = this.scheduleDates.startDate.value;
      if (!!startDate) {
        startDate.setUTCHours(12);
      }
      this.scheduleDates.endDate.value = (!!this.filter.selectedValues[1] ? new Date(this.filter.selectedValues[1]) : undefined);
      const endDate = this.scheduleDates.endDate.value;
      if (!!endDate) {
        endDate.setUTCHours(12);
        endDate.setUTCDate(endDate.getUTCDate() - 1);
      }
    }
  },
  watch: {
    scheduleDatesValues: {
      handler: function () {
        const startDateEncodedErrors = this.getDateValidationErrors(new Date(this.scheduleDates.startDate.value));
        const endDateEncodedErrors = this.getDateValidationErrors(new Date(this.scheduleDates.endDate.value));
        if (!!this.filter.config.maxPeriodInMillis &&
          ((this.scheduleDates.endDate.value - this.scheduleDates.startDate.value) > this.filter.config.maxPeriodInMillis)) {
          endDateEncodedErrors.push(DateErrorsEnum.MAX_PERIOD);
        }
        this.scheduleDates.startDate.error = this.mapErrors(startDateEncodedErrors)[0];
        this.scheduleDates.endDate.error = this.mapErrors(endDateEncodedErrors)[0];
      },
      immediate: true
    },
    filter: {
      handler: function () {
        this.initializeDates();
      },
      immediate: true
    }
  }
};
